var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMultipleFiles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 168.643,
  height: 198.607,
  viewBox: "0 0 168.643 198.607"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_24671",
  "data-name": "Group 24671",
  transform: "translate(-610 -401.186)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5478",
  "data-name": "Path 5478",
  d: "M212.484,251.615H183.43a5.667,5.667,0,0,1-5.66-5.66v-116.2a5.667,5.667,0,0,1,5.66-5.66h78.8l14.423,12.878v23.414h-.666V137.269l-14.012-12.51H183.43a5,5,0,0,0-4.994,4.994v116.2a5,5,0,0,0,4.994,4.994h29.054Z",
  transform: "translate(432.23 277.092)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5479",
  "data-name": "Path 5479",
  d: "M444.42,137.411h-8.99a5.667,5.667,0,0,1-5.66-5.66v-7.325a.333.333,0,0,1,.666,0v7.325a5,5,0,0,0,4.994,4.994h8.99a.333.333,0,1,1,0,.666Z",
  transform: "translate(264.135 277.092)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5480",
  "data-name": "Path 5480",
  d: "M282.888,214.593H206.974a2.664,2.664,0,0,0,0,5.327h75.914a2.664,2.664,0,0,0,0-5.327Z",
  transform: "translate(414.527 216.725)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5481",
  "data-name": "Path 5481",
  d: "M244.6,180.593H206.974a2.664,2.664,0,0,0,0,5.327H244.6a2.664,2.664,0,1,0,0-5.327Z",
  transform: "translate(414.527 239.405)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5482",
  "data-name": "Path 5482",
  d: "M206.974,281.593a2.664,2.664,0,0,0,0,5.327h23.793v-5.327Z",
  transform: "translate(414.527 172.034)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5483",
  "data-name": "Path 5483",
  d: "M206.974,247.593a2.664,2.664,0,0,0,0,5.327h23.793v-5.327Z",
  transform: "translate(414.527 194.712)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5484",
  "data-name": "Path 5484",
  d: "M230.546,373.049H209.224a5.5,5.5,0,0,1-5.494-5.494V339.587a5.5,5.5,0,0,1,5.494-5.494h21.323Z",
  transform: "translate(414.914 137.013)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5485",
  "data-name": "Path 5485",
  d: "M317.984,359.115H288.93a5.667,5.667,0,0,1-5.66-5.66v-116.2a5.667,5.667,0,0,1,5.66-5.66h78.8l14.423,12.878v22.082h-.666V244.769l-14.011-12.51H288.93a5,5,0,0,0-4.994,4.994v116.2a5,5,0,0,0,4.994,4.994h29.054Z",
  transform: "translate(361.857 205.385)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5486",
  "data-name": "Path 5486",
  d: "M549.92,244.911h-8.99a5.667,5.667,0,0,1-5.66-5.66v-7.325a.333.333,0,1,1,.666,0v7.325a5,5,0,0,0,4.994,4.994h8.99a.333.333,0,0,1,0,.666Z",
  transform: "translate(193.762 205.385)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5487",
  "data-name": "Path 5487",
  d: "M388.388,322.093H312.474a2.664,2.664,0,1,0,0,5.327h75.914a2.664,2.664,0,0,0,0-5.327Z",
  transform: "translate(344.154 145.018)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5488",
  "data-name": "Path 5488",
  d: "M350.1,288.093H312.474a2.664,2.664,0,1,0,0,5.327H350.1a2.664,2.664,0,1,0,0-5.327Z",
  transform: "translate(344.154 167.696)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5489",
  "data-name": "Path 5489",
  d: "M388.388,322.093H312.474a2.664,2.664,0,1,0,0,5.327h75.914a2.664,2.664,0,0,0,0-5.327Z",
  transform: "translate(344.154 145.018)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5490",
  "data-name": "Path 5490",
  d: "M350.1,288.093H312.474a2.664,2.664,0,1,0,0,5.327H350.1a2.664,2.664,0,1,0,0-5.327Z",
  transform: "translate(344.154 167.696)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5491",
  "data-name": "Path 5491",
  d: "M312.474,389.093a2.664,2.664,0,1,0,0,5.327h23.793v-5.327Z",
  transform: "translate(344.154 100.327)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5492",
  "data-name": "Path 5492",
  d: "M312.474,355.093a2.664,2.664,0,1,0,0,5.327h23.793v-5.327Z",
  transform: "translate(344.154 123.005)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5493",
  "data-name": "Path 5493",
  d: "M312.474,389.093a2.664,2.664,0,1,0,0,5.327h23.793v-5.327Z",
  transform: "translate(344.154 100.327)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5494",
  "data-name": "Path 5494",
  d: "M312.474,355.093a2.664,2.664,0,1,0,0,5.327h23.793v-5.327Z",
  transform: "translate(344.154 123.005)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5495",
  "data-name": "Path 5495",
  d: "M336.046,480.549H314.724a5.5,5.5,0,0,1-5.494-5.494V447.087a5.5,5.5,0,0,1,5.494-5.494h21.323Z",
  transform: "translate(344.541 65.306)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5496",
  "data-name": "Path 5496",
  d: "M389.98,338.425a5.658,5.658,0,0,0-2.71,4.828v.832h.666v-.832a5,5,0,0,1,3.712-4.828Zm81.754-.832h-78.8a5.667,5.667,0,0,0-5.66,5.66v116.2a5.668,5.668,0,0,0,5.66,5.66H480.5a5.668,5.668,0,0,0,5.66-5.66V350.472Zm13.758,121.862a5,5,0,0,1-4.994,4.994H392.93a5,5,0,0,1-4.994-4.994v-116.2a5,5,0,0,1,3.712-4.828,4.935,4.935,0,0,1,1.282-.167h78.551l14.011,12.509ZM389.98,338.425a5.658,5.658,0,0,0-2.71,4.828v.832h.666v-.832a5,5,0,0,1,3.712-4.828Z",
  transform: "translate(292.485 134.678)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5497",
  "data-name": "Path 5497",
  d: "M653.92,350.911h-8.99a5.667,5.667,0,0,1-5.66-5.66v-7.325a.333.333,0,1,1,.666,0v7.325a5,5,0,0,0,4.994,4.994h8.99a.333.333,0,1,1,0,.666Z",
  transform: "translate(124.389 134.678)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5498",
  "data-name": "Path 5498",
  d: "M492.39,433.42H416.476a2.664,2.664,0,1,1,0-5.327H492.39a2.664,2.664,0,1,1,0,5.327Z",
  transform: "translate(274.78 74.312)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5499",
  "data-name": "Path 5499",
  d: "M454.1,399.42H416.476a2.664,2.664,0,1,1,0-5.327H454.1a2.664,2.664,0,1,1,0,5.327Z",
  transform: "translate(274.78 96.99)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5500",
  "data-name": "Path 5500",
  d: "M492.39,500.42H416.476a2.664,2.664,0,1,1,0-5.327H492.39a2.664,2.664,0,1,1,0,5.327Z",
  transform: "translate(274.78 29.62)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5501",
  "data-name": "Path 5501",
  d: "M454.1,466.42H416.476a2.664,2.664,0,1,1,0-5.327H454.1a2.664,2.664,0,1,1,0,5.327Z",
  transform: "translate(274.78 52.298)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5502",
  "data-name": "Path 5502",
  d: "M489.309,586.549H418.723a5.5,5.5,0,0,1-5.494-5.494V553.087a5.5,5.5,0,0,1,5.494-5.494h70.587a5.5,5.5,0,0,1,5.494,5.494v27.968A5.5,5.5,0,0,1,489.309,586.549Z",
  transform: "translate(275.169 -5.401)",
  fill: "#4b93ff"
}))));
export { SvgMultipleFiles as ReactComponent };
export default __webpack_public_path__ + "static/media/multiple-files.e7bab08c2231d45cadc972cac551e366.svg";